import { render, staticRenderFns } from "./featured.vue?vue&type=template&id=4fb762d6&scoped=true&"
import script from "./featured.vue?vue&type=script&lang=js&"
export * from "./featured.vue?vue&type=script&lang=js&"
import style0 from "./featured.vue?vue&type=style&index=0&id=4fb762d6&prod&lang=less&scoped=true&"
import style1 from "./featured.vue?vue&type=style&index=1&id=4fb762d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb762d6",
  null
  
)

export default component.exports